import sanitizeHTML from "sanitize-html";
import linkifyHTML from "linkifyjs/html";

export { copyTextToClipboard } from "@clockwise/web-commons/src/util/html.util";

export const sanitizeAndLinkify = (unsanitaryHTML: string, convertNewLine = true) => {
  let html = unsanitaryHTML;
  if (convertNewLine) {
    html = unsanitaryHTML.replace(/\n/g, "<br />");
  }

  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = sanitizeHTML(linkifyHTML(html));
  tempDiv.querySelectorAll("a").forEach((anchorElement) => {
    anchorElement.setAttribute("target", "_blank");
  });

  return sanitizeHTML(tempDiv.innerHTML);
};

export const getTextFromHTML = (html: string) => {
  return sanitizeHTML(html, {
    allowedTags: [],
  });
};

export const addTextToClipboard = (text: string, callback?: (success: boolean) => void) => {
  console.warn(
    `deprecated this util in favor of the 'copyTextToClipboard' function; please switch over`,
  );
  // create element
  const id = "clockwise-temp-clipboard-element";
  const input = document.createElement("input");
  input.setAttribute("type", "text");
  input.setAttribute("value", text);
  input.id = id;

  // append element to body
  document.body.appendChild(input);

  // wait some time
  setTimeout(() => {
    input.select();
    const success = document.execCommand("copy");
    const el = document.getElementById(id);
    if (el) {
      el.remove();
    }
    if (callback) {
      callback(success);
    }
  }, 250);
};
